import ComponentHeaderShowAll from "./HeaderShowAll";
import CounterInline from "./components/CounterInline/HeaderShowAllCounterInline";
import RightButtonInline from "./components/RightAddon/HeaderShowAllRightButtonInline";
import Subtitle from "./components/Subtitle/HeaderShowAllSubtitle";
import Title from "./components/Title/HeaderShowAllTitle";

export interface IHeaderShowAllExtensions {
    Title: typeof Title;
    CounterInline: typeof CounterInline;
    Subtitle: typeof Subtitle;
    RightButtonInline: typeof RightButtonInline;
}

export const HeaderShowAll: typeof ComponentHeaderShowAll &
    IHeaderShowAllExtensions = Object.assign(ComponentHeaderShowAll, {
    Title,
    CounterInline,
    Subtitle,
    RightButtonInline,
});
